import React, { useState } from 'react';
const playSvg = '/icons/video/play-ic.svg';
import Text from '../../../../../components/atoms/text/Text';
import styles from './ParallaxSection.module.scss';
function Dash({ year, isShort, isActive, onClick, hasVideo }) {
  const [isClickable, setIsClickable] = useState(true);
  const barClass = isActive ? 'year_bar year_bar_active' : 'year_bar';

  const handleClick = () => {
    if (!isClickable) return;
    onClick();
    setIsClickable(false);
    setTimeout(() => {
      setIsClickable(true);
    }, 500);
  };

  return (
    <div className="year_li" onClick={handleClick}>
      <li className="year_li">
        <div className={barClass}>
          {hasVideo ? (
            <img
              src={playSvg}
              className={`${styles['vid-image']} dashes-image`}
            />
          ) : null}
          <Text
            title={year}
            variant="text-regular-16"
            className={styles['text-dash']}
          />
        </div>
      </li>
    </div>
  );
}

export default Dash;
